
export const HOME = "/";
export const LOGIN = "/login";
export const IMPORT = "/import";
export const EXPORT = "/export";
export const CUSTOMER = "/customer";
export const SCHOOL = "/school";
export const PROFILE = "/profile";
export const SETTING = "/setting";
export const CONTENT = "/content";
export const BANK = "/bank";
export const CONFIG = "/config";
export const PRIVACY = "/privacy";